import * as React from "react";
import { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { CiMenuKebab } from "react-icons/ci";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {
  MdOutlineStickyNote2,
  MdOutlineInventory2,
  MdRemoveRedEye,
  MdAdd,
  MdOutlineHistory,
  MdLockReset,
} from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { RiSubtractLine } from "react-icons/ri";
import { PiUsersThree } from "react-icons/pi";
import { CiCalculator1 } from "react-icons/ci";
import LoginUserModel from "../../../LoginUser/LoginUser";
import { useTranslation } from "react-i18next";

export default function CustomMenu({
  row,
  setAddBalanceModal,
  setSubtractBalanceModal,
  setChangePassword,
  setEditUserModal,
  setOpenDetailsModal,
  setOpenClientsModal,
  setOpenHelperUsersModal,
  setOpenProductsModal,
  setHistoryModal,
  setConfirmDelete,
  setFormulaModal,
  setInvoicesHistoryModal,
}) {
  const { t } = useTranslation("admin");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const [loginModal, setLoginModal] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <LoginUserModel open={loginModal} setOpen={setLoginModal} />

      <div className="table_action__wrap">
        <div
          className={`table_action__btn ${
            [false, "false", "0", null, undefined].includes(
              row?.user?.account_status,
            )
              ? "table_action__btn__disabled"
              : ""
          }`}
          onClick={() => {
            setLoginModal(row?.user);
          }}
        >
          {t("users.login")}
        </div>
        <div className="table_action__btn" onClick={handleClick}>
          <CiMenuKebab size={10} style={{ marginRight: "2px" }} />
          {t("users.more")}
        </div>
        <Menu
          id={`basic-menu-${row.id}`} // Unique ID for each row
          anchorEl={anchorEl}
          open={open}
          size="small"
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": `basic-button-${row.id}`, // Unique ID for each row
            "box-shadow": "none",
          }}
        >
          <MenuItem
            className="boltTable__action_more_btn_label"
            key="Add"
            onClick={() => {
              setAddBalanceModal(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <MdAdd size={15} />
            </ListItemIcon>
            <ListItemText>{t("users.addBalance")}</ListItemText>
          </MenuItem>
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setSubtractBalanceModal(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <RiSubtractLine size={15} />
            </ListItemIcon>
            <ListItemText>{t("users.subtractBalance")}</ListItemText>
          </MenuItem>
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setChangePassword(row.user_id);
              handleClose();
            }}
          >
            <ListItemIcon>
              <MdLockReset size={15} />
            </ListItemIcon>
            <ListItemText>{t("users.resetPassword")}</ListItemText>
          </MenuItem>
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setEditUserModal(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <FaRegEdit size={15} />
            </ListItemIcon>
            <ListItemText>{t("common:actions.edit")}</ListItemText>
          </MenuItem>
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setOpenDetailsModal(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <MdRemoveRedEye size={15} />
            </ListItemIcon>
            <ListItemText>{t("users.details")}</ListItemText>
          </MenuItem>
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setFormulaModal(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <CiCalculator1 size={15} />
            </ListItemIcon>
            <ListItemText>{t("users.formula")}</ListItemText>
          </MenuItem>
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setInvoicesHistoryModal(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <MdOutlineStickyNote2 size={15} />
            </ListItemIcon>
            <ListItemText>{t("users.invoices")}</ListItemText>
          </MenuItem>
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setOpenClientsModal(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <PiUsersThree size={15} />
            </ListItemIcon>
            <ListItemText>{t("users.clients")}</ListItemText>
          </MenuItem>
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setOpenHelperUsersModal(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <PiUsersThree size={15} />
            </ListItemIcon>
            <ListItemText>{t("users.helperUsers")}</ListItemText>
          </MenuItem>
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setOpenProductsModal(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <MdOutlineInventory2 size={15} />
            </ListItemIcon>
            <ListItemText>{t("users.products")}</ListItemText>
          </MenuItem>
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setHistoryModal(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <MdOutlineHistory size={15} />
            </ListItemIcon>
            <ListItemText>{t("users.transactions")}</ListItemText>
          </MenuItem>
          {/* <MenuItem
        className="boltTable__action_more_btn_label"
          onClick={() => {
            setConfirmDelete(row);
            handleClose();
          }}
        >
          <ListItemIcon>
            <BsTrash size={15} />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem> */}
        </Menu>
      </div>
    </>
  );
}
